import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
const FeedbackNavItem = () => {
  const feedbackCount = useSelector((state) => state.MenuCount.feedbackCount);
  
  return (
      <span className="feedback-nav-item">
            Terugkoppeling
            {feedbackCount > 0 && ` (${feedbackCount})`}
        </span>

  );
}
export default FeedbackNavItem;
